<app-spinner *ngIf="isLoading" placement="full-page" size="34px"></app-spinner>

<app-page-wrapper *ngIf="!isLoading" scrollable="true">

  <div class="account-content">
    <div class="account-header">
      <app-heavy-header title="Your Subscription"></app-heavy-header>
    </div>

    <div class="sub-card">

      <div class="sub-detail-row">

        <div class="sub-decoration">
          <app-svg-loader class="acct-light-theme" height="288px"
            url="assets/illustrations/subscription-illustration-light.svg"></app-svg-loader>
          <app-svg-loader class="acct-dark-theme" height="288px"
            url="assets/illustrations/subscription-illustration-dark.svg"></app-svg-loader>
        </div>

        <div class="sub-detail">
          <!-- SUBBED -->
          <ng-container *ngIf="appState?.user.subscription()?.isSubscribed">

            <div class="sub-title" *ngIf="!currentSub.cancelAtPeriodEnd; else cancelHeaderTemplate">
              Active
            </div>
            <ng-template #cancelHeaderTemplate>
              <div class="sub-title">
                Canceled
              </div>
            </ng-template>

            <div class="sub-desc" *ngIf="!currentSub.cancelAtPeriodEnd; else cancelTemplate">
              Your membership to TailOne is active and will renew for $499.00 on: {{currentSub.currentPeriodEnd |
              date:'longDate'}}
            </div>
            <ng-template #cancelTemplate>
              <div class="sub-desc">
                Your membership has been cancelled and you will lose benefits on: {{currentSub.currentPeriodEnd |
                date:'longDate'}}
              </div>
            </ng-template>

            <div class="sub-actions-row" *ngIf="!currentSub.cancelAtPeriodEnd">
              <div class="action" (click)="onToggleCancelTray()">Cancel Subscription</div>
            </div>
            <div class="sub-actions-row" *ngIf="currentSub.cancelAtPeriodEnd">
              <div class="action" (click)="onToggleResumeTray()">Resume Subscription</div>
            </div>
          </ng-container>

          <!-- FREE ACCESS -->
          <ng-container *ngIf="!appState?.user.subscription()?.isSubscribed && entitlementReason === 'free-access-granted'">
            <div class="sub-title">
              Complimentary Access
            </div>

            <div class="sub-desc">
              You have been granted free access to TailOne by an administrator. You can use the app and services without a subscription.
            </div>
          </ng-container>

          <!-- NOT SUBBED -->
          <ng-container *ngIf="!appState?.user.subscription()?.isSubscribed && subscriptionState === 'inactive'">
            <div class="sub-title">
              Subscribe to Continue Benefits
            </div>

            <div class="sub-desc">
              Your trail period has ended or you have made a successful connection.
            </div>

            <div class="sub-actions-row">
              <div class="action" (click)="onClickSubscribe()">Activate Subscription</div>
            </div>
          </ng-container>

          <!-- TRIAL -->
          <ng-container *ngIf="!appState?.user.subscription()?.isSubscribed && subscriptionState === 'trial'">
            <div class="sub-title">
              Trail Window
            </div>

            <div class="sub-desc">
              We want to make sure you have time to see the value in TailOne. Your trial will end {{ renewalDate |
              date:'longDate' }} or after your first connection.
            </div>

            <div class="sub-actions-row">
              <div class="action" (click)="onClickSubscribe()">Subscribe Now</div>
            </div>
          </ng-container>

        </div>
      </div>
    </div>
  </div>

  <div class="delete-account-row">
    <app-secondary-btn destructive="true" (click)="onClickDelete()" *ngIf="!needsReauth">
      <div class="flex center-center" style="gap: 8px" *ngIf="!isProcessing">
        <app-svg-loader height="18px" url="assets/svg/trash-outline.svg"></app-svg-loader>
        <!-- TODO: handle inline styles -->
        <div style="color: var(--text-primary); font-size: 14px;">{{deleteText}}</div>
      </div>
      <app-spinner variant="btn-spinner" *ngIf="isProcessing"></app-spinner>
    </app-secondary-btn>

    <app-secondary-btn destructive="true" (click)="onClickReauth()" *ngIf="needsReauth">
      <div class="flex center-center" style="gap: 8px">
        <app-svg-loader height="18px" url="assets/svg/trash-outline.svg"></app-svg-loader>
        <!-- TODO: handle inline styles -->
        <div style="color: var(--text-primary); font-size: 14px;">{{deleteText}}</div>
      </div>
    </app-secondary-btn>
  </div>


</app-page-wrapper>

<app-pop-tray *ngIf="showCancelSub" [header]="'Cancel Subscription'" [description]="cancellationMessage"
  [actions]="cancelActions">
</app-pop-tray>

<app-pop-tray *ngIf="showResumeSub" [header]="'Resume Subscription'"
  [description]="'Your subscription will continue and be charged on your next renewal date.'" [actions]="resumeActions">
</app-pop-tray>